import {Component, OnInit} from '@angular/core';
import {VerbalActionEntryService} from '../../../services/verbal-action/verbal-action-entry.service';
import {ActivatedRoute} from '@angular/router';
import {NotificationService} from '../../../services/common/notification.service';
import {AuthService} from '../../../services/auth/auth.service';
import {References} from '../../../dtos/references';
import {SharedService} from '../../../services/common/shared.service';
import {FormOptionsLists} from '../../../shared/FormOptionsLists';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {VerbalActionEntryDto} from "../../../dtos/verbal-action/entry/verbal-action-entry-dto";
import {VerbalActionEntryCreationDto} from "../../../dtos/verbal-action/entry/verbal-action-entry-creation-dto";

@Component({
  selector: 'app-verbal-action-detail',
  templateUrl: './verbal-action-detail.component.html',
  styleUrls: ['./verbal-action-detail.component.scss'],
  standalone: false
})
export class VerbalActionDetailComponent implements OnInit {

  currentEntryId: number;
  verbalAction: VerbalActionEntryDto;
  displayEditingTools = false;
  references: References;

  formOptionsLists = new FormOptionsLists();
  levelList = this.formOptionsLists.levelList;

  formGroup: UntypedFormGroup;

  constructor(private verbalActionEntryService: VerbalActionEntryService,
              public authService: AuthService,
              private route: ActivatedRoute,
              private notificationService: NotificationService,
              private fb: UntypedFormBuilder,
              public sharedService: SharedService) {
  }

  ngOnInit() {
    this.formGroup = this.fb.group({
      name: [''],
      receptive: [''],
      productive: [''],
      examples: [''],
    });
    this.route.params.subscribe((params) => {
      this.currentEntryId = params['id'];
      this.getEntry();
    });
  }

  getEntry() {
    this.verbalActionEntryService.getEntry(this.currentEntryId).subscribe({
      next: (data) => {
        this.verbalAction = data;
        this.references = this.sharedService.extractReferences(data)['Verweise'];
        this.setForm(data);
        this.toggleEditingTools(false);
      },
      error: (error) => {
        this.notificationService.openSnackBar(error);
      }
    });
  }

  setForm(data: VerbalActionEntryDto) {
    this.formGroup.controls['name'].setValue(data.name);
    this.formGroup.controls['receptive'].setValue(data.receptive);
    this.formGroup.controls['productive'].setValue(data.productive);
    this.formGroup.controls['examples'].setValue(data.examples?.join('\n') || '');
  }

  toggleEditingTools(change: boolean) {
    if (change) {
      this.displayEditingTools = !this.displayEditingTools;
    }
  }

  saveChanges() {
    const formValue = this.formGroup.value;
    const examples = formValue.examples ? formValue.examples.split('\n').filter((e: string) => e.trim() !== '') : [];
    const entry = new VerbalActionEntryCreationDto(
      this.verbalAction.id,
      formValue.name,
      formValue.receptive,
      formValue.productive,
      examples,
      null, // categoryId - preserve existing
      this.sharedService.getIds(this.references?.vocabCategories),
      this.sharedService.getIds(this.references?.vocabEntries),
      this.sharedService.getIds(this.references?.functionalGrammarCategories),
      this.sharedService.getIds(this.references?.functionalGrammarEntries),
      this.sharedService.getIds(this.references?.systemicGrammarCategories),
      this.sharedService.getIds(this.references?.systemicGrammarEntries),
      this.sharedService.getIds(this.references?.textPatterns),
      this.sharedService.getIds(this.references?.textTypes),
      this.sharedService.getIds(this.references?.detailedCanDoStatementCategories),
      this.sharedService.getIds(this.references?.detailedCanDoStatementEntries),
      this.sharedService.getIds(this.references?.globalCanDoStatementCategories),
      this.sharedService.getIds(this.references?.globalCanDoStatementEntries),
      this.sharedService.getIds(this.references?.['verbalActionCategories']),
      this.sharedService.getIds(this.references?.['verbalActionEntries'])
    );
    this.verbalActionEntryService.updateEntry(this.currentEntryId, entry).subscribe(
      data => {
        this.verbalAction = data;
        this.notificationService.openSnackBar('Sprachhandlung erfolgreich gespeichert.');
      }, error => {
        this.notificationService.openSnackBar(error);
      }
    );
  }

  updateReferences() {
    const examples = this.verbalAction.examples || [];
    const entry = new VerbalActionEntryCreationDto(
      this.verbalAction.id,
      this.verbalAction.name,
      this.verbalAction.receptive,
      this.verbalAction.productive,
      examples,
      null, // categoryId - preserve existing
      this.sharedService.getIds(this.references?.vocabCategories),
      this.sharedService.getIds(this.references?.vocabEntries),
      this.sharedService.getIds(this.references?.functionalGrammarCategories),
      this.sharedService.getIds(this.references?.functionalGrammarEntries),
      this.sharedService.getIds(this.references?.systemicGrammarCategories),
      this.sharedService.getIds(this.references?.systemicGrammarEntries),
      this.sharedService.getIds(this.references?.textPatterns),
      this.sharedService.getIds(this.references?.textTypes),
      this.sharedService.getIds(this.references?.detailedCanDoStatementCategories),
      this.sharedService.getIds(this.references?.detailedCanDoStatementEntries),
      this.sharedService.getIds(this.references?.globalCanDoStatementCategories),
      this.sharedService.getIds(this.references?.globalCanDoStatementEntries),
      this.sharedService.getIds(this.references?.['verbalActionCategories']),
      this.sharedService.getIds(this.references?.['verbalActionEntries'])
    );
    this.verbalActionEntryService.updateEntry(this.currentEntryId, entry).subscribe({
      next: data => {
        this.verbalAction = data;
        this.notificationService.openSnackBar('Sprachhandlung erfolgreich gespeichert.');
      },
      error: error => {
        this.notificationService.openSnackBar(error);
      }
    });
  }

  handleReferenceChange($event: References) {
    this.references = $event;
    this.updateReferences();
  }
}
